import Cookies from "universal-cookie";
let cookies = new Cookies;


// Delete all the storage from the browser when the user logged out
export const logout = () => {    
    cookies.set("userObject", '', { path: "/", maxAge: 0 });
    cookies.set("accessToken", '', { path: "/", maxAge: 0 });
    localStorage.removeItem("accessToken");
    localStorage.clear();
    window.open('/app','_self');
}
